import React from "react";
import { useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import { gbState } from "../../components/shared/GlobalState";
import CardBackground from "./CardBackground";

import MainTemplate from "../../components/MainTemplate/MainTemplate";

import ProfileComponent from "./ProfileComponent";
import CenterStageSection from "./CenterStageSection";
import TimelineSection from "./TimelineSection";
const SuperAdminDashboard = () => {
  let navigate = useNavigate();
  const [{ errorLogApi, placeHolderText, Category, user }] = useAtom(gbState);

  return (
    <MainTemplate>
      {/* <div className="flex flex-grow bg-gray-100">
        <div className="flex flex-grow bg-gray-100">
          <div className="w-full md:hidden">
            <TimelineSection />
          </div>
          <div className="hidden md:flex md:w-4/5">
            <div className="flex w-full overflow-y-auto">
              <CenterStageSection />
            </div>
          </div>
        </div>
      </div> */}
      {/* <CenterStageSection /> */}
      <CardBackground>
        <button
          onClick={() => navigate("/churchonboard")}
          className="px-4 py-2 ml-auto font-bold text-white bg-blue-500 rounded hover:bg-blue-700"
        >
          Add Church
        </button>
      </CardBackground>
      <TimelineSection />
    </MainTemplate>
  );
};

export default SuperAdminDashboard;
